import axios from 'axios';
import mbpLogger from 'mbp-logger';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var windowHostname;
var ENV_OBJ = {
  protocol: undefined,
  host: undefined,
  rootUri: 'r/api/config/',
  branch: undefined
};
var HTTP_HEADER_ACCEPTED_ENCODING = 'gzip, deflate';
var getEnvVarValue = function getEnvVarValue(variableName) {
  var value = process.env[variableName];
  try {
    if (windowHostname) {
      if (windowHostname.toLowerCase().indexOf('dev') !== -1) {
        value = process.env["".concat(variableName, "_DEV")];
      }
      if (windowHostname.toLowerCase().indexOf('uat') !== -1) {
        value = process.env["".concat(variableName, "_UAT")];
      }
    }
  } catch (ex) {
    mbpLogger.logError({
      variableName: variableName,
      "function": 'getEnvVarValue',
      module: 'config-server-api',
      jsError: ex,
      message: 'getEnvVarValue failed'
    });
  }
  return value || process.env[variableName];
};
var setHost = function setHost() {
  if (!ENV_OBJ.host) {
    if (windowHostname) {
      var wcHost = getEnvVarValue('APP_WC_HOST');
      windowHostname = windowHostname === 'localhost' ? 'dev1.origin-gcp.800-flowers.net' : windowHostname;
      ENV_OBJ.host = wcHost || windowHostname || 'localhost';
    } else {
      ENV_OBJ.host = process.env.APP_CONFIG_HOST_SSR || 'localhost';
    }
  }
};
var setProtocol = function setProtocol() {
  if (!ENV_OBJ.protocol) {
    if (windowHostname) {
      ENV_OBJ.protocol = process.env.APP_WC_PROTOCOL || 'https';
    } else {
      ENV_OBJ.protocol = process.env.APP_WC_PROTOCOL_SSR || 'https';
    }
  }
};
var setPrefix = function setPrefix() {
  if (!ENV_OBJ.prefix) {
    if (windowHostname) {
      ENV_OBJ.prefix = typeof process.env.APP_API_PREFIX !== 'undefined' ? process.env.APP_API_PREFIX : '/r/api/config/';
    } else {
      ENV_OBJ.prefix = typeof process.env.APP_CONFIG_API_PREFIX_SSR !== 'undefined' ? process.env.APP_CONFIG_API_PREFIX_SSR : '/';
    }
  }
};
var setHeaders = function setHeaders(headersInput) {
  var headers = _objectSpread({}, headersInput);
  if (!windowHostname) {
    headers['Accept-Encoding'] = HTTP_HEADER_ACCEPTED_ENCODING;
  }
  return headers;
};
var CONFIG_ENV = function CONFIG_ENV() {
  if (!ENV_OBJ.host) {
    windowHostname = typeof window !== 'undefined' && window.location && window.location.hostname;
    mbpLogger.logDebug({
      windowHostname: windowHostname,
      APP_WC_HOST: process.env.APP_WC_HOST,
      APP_WC_HOST_SSR: process.env.APP_WC_HOST_SSR,
      APP_API_PREFIX_SSR: process.env.APP_API_PREFIX_SSR,
      "function": '"production"',
      module: 'config-server-api',
      message: 'Environment variables'
    });
    setHost();
    setPrefix();
    setProtocol();
    mbpLogger.logDebug({
      ENV_OBJ: ENV_OBJ,
      "function": '"production"',
      module: 'config-server-api',
      message: 'Environment variables'
    });
  }
  return ENV_OBJ;
};

/**
 *
 * @param method    - get/post/put/delete/etc
 * @param url       - string for url to call
 * @param params    - object with parameters to be added to the url
 * @param data      - body
 * @param env     -  environment properties
 * @param header    - object with headers to be added to the request
 */
var callAxios = function callAxios(method, url, params, data, env, headers) {
  try {
    var config = {
      method: method,
      url: url,
      params: _objectSpread({}, params),
      headers: setHeaders(headers),
      data: data
    };
    config.headers = _objectSpread({}, config.headers);
    return axios(config);
  } catch (ex) {
    mbpLogger.logError({
      method: method,
      url: url,
      params: params,
      data: data,
      env: env,
      headers: headers,
      "function": 'callAxios',
      module: 'config server api',
      jsError: ex,
      message: 'callAxios FAILED'
    });
  }
  return null;
};

/**
 * @param {*} env
 * @param {*} configName
 * @param {*} branch
 */

var getUrl = function getUrl(env, configName, branch) {
  mbpLogger.logDebug({
    env: env,
    configName: configName,
    envObj: CONFIG_ENV(),
    "function": 'getUrl',
    module: 'config-server-api',
    message: 'getUrl variables'
  });
  var hostUrl = "".concat(env.protocol || CONFIG_ENV().protocol, "://").concat(env.host || CONFIG_ENV().host);
  var uri = "".concat(env.prefix || CONFIG_ENV().prefix);
  var br = "".concat(branch || env.branch || 'master');
  var url = "".concat(hostUrl).concat(uri).concat(configName, "/").concat(br);
  mbpLogger.logDebug({
    url: url,
    uri: uri,
    hostUrl: hostUrl,
    "function": 'getUrl',
    module: 'config server api',
    message: 'getUrl variables'
  });
  return url;
};

/**
 * GET for config server
 * @param {*} env
 * @param {*} configName
 * @param {*} params
 * @param {*} branch
 */
var getConfig = function getConfig(env, configName, branch) {
  try {
    var url = getUrl(env, configName, branch);
    return callAxios('get', url, null, null, env);
  } catch (ex) {
    mbpLogger.logError({
      env: env,
      configName: configName,
      "function": 'getConfig',
      module: 'config serverapi',
      jsError: ex,
      message: 'config server SDK getConfig failed'
    });
  }
  return null;
};

/**
 * @class WC API Core
 */
var ConfigClient = {
  getConfig: getConfig
};
export { ConfigClient as default };